import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { FaTelegram, FaTiktok, FaDiscord  } from "react-icons/fa";
import { SiX } from "react-icons/si";

function HomeSocial() {

    return(
        <>
        <Container fluid className="home-about-section">
            <Row > 
                <Col>
                 <Col md={12} className="home-about-social">
            
            <p>
              <span className="purple">connect </span>with us
            </p>
            <ul className="home-about-social-links">
              <li className="social-icons">
                {/* <a
                  href="https://github.com/soumyajit4419"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiFillGithub />
                </a> */}
              </li>
              <li className="social-icons">
                <a
                  href="https://x.com/FontanaEcoTem"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <SiX  />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://t.me/FontanaEcosystem"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <FaTelegram  />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.tiktok.com/@fontanaecosystem"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <FaTiktok />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://discord.gg/uC5KPBqqK"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <FaDiscord />
                </a>
              </li>
            </ul>
          </Col>
                </Col>
            </Row>
        </Container>
        
        
        
        </>

    );


}
export default HomeSocial;